import React from 'react';
import Icon from "./Icon";

const IconJacuzzi = ({tooltip}) => {
    return (
        <Icon image="/img/icons/icon-jacuzzi.svg" tooltip={tooltip}/>
    )
};

export default IconJacuzzi;